export const BUDGET_HISTORY = '/budget-history/';
